import { useForm } from 'react-hook-form';
import { Checkbox, FormProvider, SelectTag, TextField } from '../../../../../components';
import { Button, Grid, Stack, Typography ,IconButton} from '@mui/material';
import { yupResolver } from '@hookform/resolvers/yup';
import CloseIcon from '@mui/icons-material/Close';
import * as Yup from 'yup';

export const IVFTreatementPatientHistory = ({ onAdd, onClose, setPatientHistoryDialog}) => {
  const methods = useForm({
    resolver: yupResolver(
      Yup.object().shape({
        married_year: Yup.string().required(' ')
      })
    ),
    mode: 'all'
  });
  const { handleSubmit, reset } = methods;
  const formSubmit = (formValue) => {
    onAdd(formValue);
    setPatientHistoryDialog(false);
  };

  return (
    <FormProvider methods={methods} onSubmit={handleSubmit(formSubmit)}>
       <Stack direction="row" spacing={2} alignItems="center" justifyContent="space-between" sx={{ marginBottom:1, borderBottom: 1, borderColor: 'grey.300', paddingBottom: 2 }}>
        <Typography variant="h4" fontWeight="bold" sx={{ marginBottom: "2%", fontSize: "1.5rem", color: "#333" }}>
          Patient History
        </Typography>
        <IconButton onClick={onClose} sx={{ color: 'red' }}>
          <CloseIcon fontSize="large" />
        </IconButton>
      </Stack>
      <Grid item xs={12} sx={{ display: 'flex', flexDirection: 'column', gap: 2, marginLeft: '1%'}}>
        <Stack spacing={2}>
          <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
            <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>Married Year</Typography>
            <TextField sx={{ flex: 1 }} name="married_year" placeholder="Enter Married Years" type="number" />
          </Stack>
          <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
            <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>Marriage No's</Typography>
            <TextField sx={{ flex: 1 }} name="marriage_no" placeholder="Enter Marriage No's" type="number"/>
          </Stack>
          <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
            <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>Previous Delivery</Typography>
            <TextField sx={{ flex: 1 }} name="previous_delivery" placeholder="Previous Delivery" />
          </Stack>
          <Stack spacing={0.5} direction="row" alignItems="center" sx={{ width: '100%' }}>
            <Typography sx={{ flex: 0.4, fontWeight: 600, fontSize: '1.4rem' }}>Delivery Type</Typography>
            <TextField sx={{ flex: 1 }} name="delivery_type" placeholder="Delivery Type" />
          </Stack>
        </Stack>
      </Grid>

      <Stack spacing={1} direction="row" alignItems="center" justifyContent="flex-end" marginTop="5%">
        <Button variant="contained" type="submit">
          Add
        </Button>
        <Button color="error" onClick={onClose}>
          Close
        </Button>
      </Stack>
    </FormProvider>
  );
};
